import React , {useState , useEffect} from 'react';
import { Row , Col , Pagination , Spinner } from 'react-bootstrap';
import Button from '../../components/common/Button/Button';
import './menu.css';
import { showToast } from '../../components/common/ToastNotification/ToastNotification';
import { getMenu , deleteMenuById } from '../../api/service/menu.service';
import { MdEdit , MdDelete } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { IoIosAddCircle } from "react-icons/io";
import { IoEye } from "react-icons/io5";

const Menu = () => {
    const [menuList , setMenuList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading , setLoading] = useState(false);
    let navigate = useNavigate();
    
    const fetchMenus = async () => {
        try {
            setLoading(true);
            const res = await getMenu({ limit: 10 , page });
            setMenuList(res.data.data || []);
            setPage(res.currentPage);
            setTotalPages(res.lastPage);
        } catch (error) {
            console.error("Failed to fetch Menus:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMenus();
    }, [page]);

    const handleDelete = (rowData) => {
        const id = rowData
        Swal.fire({
          title: "Are you sure to delete this Menu ?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#C39B22",
          cancelButtonColor: "#d32f2f",
          confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
            let result =  await deleteMenuById(id);
    
              Swal.fire({
                title: "Deleted!",
                text: "Menu has been deleted successfully.",
                icon: "success",
                confirmButtonColor: "#C39B22",
              });
    
              fetchMenus();
              showToast.success("Menu deleted successfully");
            } catch (error) {
              console.error("Delete error:", error);
              showToast.error("Failed to delete the Menu. Please try again.");
              Swal.fire({
                title: "Error!",
                text: "Something went wrong while deleting.",
                icon: "error",
                confirmButtonColor: "#C39B22",
              });
            }
          }
        });
    };

    return (
        <>
            <div className='menu-header'>
                <h3 className='menu'>Menu Management</h3>
                <Button onClick={() => navigate('/add-menu')}>Add Menu + </Button>
            </div>


            {loading ? 
                <div className='loader'>
                    <Spinner animation="border" />
                </div>
                :
                <div>
                    <Row className="g-3 mt-2">
                        {menuList.map((menu) => (
                            <Col xl={12} lg={12} md={12} sm={12} key={menu.id}>
                            
                            <div className="card">
                                <div className="card-inner">
                                <p className="menu-name">{menu.name}</p>
                                <div>
                                    {menu.categories.length > 0 &&
                                        <div
                                            className="action-pill"
                                                onClick={() => navigate("/add-product-category")}
                                            >
                                            <IoIosAddCircle size={18} />
                                            <span>Add Product Category</span>
                                        </div>
                                    }
                                    {(menu.is_customizable == 1 || menu.is_customizable == true) &&
                                        <div
                                            className="action-pill"
                                                onClick={() => navigate(`/custom-page/${menu.id}`)}
                                            >
                                            <IoEye size={18}/>
                                            <span>View Page</span>
                                        </div>
                                    }
                                    <div
                                        className="action-circle"
                                        onClick={() => navigate(`/update-menu/${menu.id}`)}
                                    >
                                        <MdEdit size={18} />
                                    </div>
                                    <div
                                        className="action-circle"
                                        onClick={() => handleDelete(menu.id)}
                                    >
                                        <MdDelete size={18} />
                                    </div>
                                </div>
                                </div>
                            </div>

                            {menu.categories?.map((category) => (
                                <div key={category.menu_id} className="ms-3 mt-2" style={{marginLeft:'40px'}}>
                                    <div className="card">
                                        <div className="card-inner">
                                            <p className="menu-name">{category.title}</p>
                                            <div>
                                                <div
                                                    className="action-pill"
                                                        onClick={() => navigate(`/add-product/${category.id}`)}
                                                    >
                                                    <IoIosAddCircle size={18} />
                                                    <span>Add Product</span>
                                                </div>
                                                <div
                                                    className="action-circle"
                                                    onClick={() => navigate(`/update-product-category/${category.id}`)}
                                                >
                                                    <MdEdit size={18} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {category.products?.map((product) => (
                                        <div key={product.category_id} className="ms-4 mt-2" style={{marginLeft:'40px'}}>
                                            <div className="card">
                                                <div className="card-inner">
                                                    <p className="menu-name">{product.title}</p>
                                                    <div>
                                                        <div
                                                            className="action-circle"
                                                            onClick={() => navigate(`/update-product/${product.id}`)}
                                                        >
                                                            <MdEdit size={18} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}

                            </Col>
                        ))}
                    </Row>


                    {totalPages > 1 &&
                        <div className="d-flex justify-content-center mt-4">
                            <Pagination>
                            <Pagination.Prev
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                            />

                            {[...Array(totalPages)].map((_, index) => (
                                <Pagination.Item
                                    key={index}
                                    active={page === index + 1}
                                    onClick={() => setPage(index + 1)}
                                >
                                    {index + 1}
                                </Pagination.Item>
                            ))}

                            <Pagination.Next
                                disabled={page === totalPages}
                                onClick={() => setPage(page + 1)}
                            />
                            </Pagination>
                        </div>
                    }

                </div>
            }

        </>
    )
}

export default Menu